import React from 'react'

const Document = ({ color = '#676767' }: { color?: string }) => {
  return (
    <svg
      width='22'
      height='22'
      viewBox='0 0 22 22'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M5.66699 7.00017H16.333M5.66699 11.0002H16.333M5.66699 15.0002H16.333M17.333 20.4932H4.66699C3.00999 20.4932 1.66699 19.1502 1.66699 17.4932V4.82617C1.66699 3.16917 3.00999 1.82617 4.66699 1.82617H17.334C18.991 1.82617 20.334 3.16917 20.334 4.82617V17.4932C20.333 19.1502 18.99 20.4932 17.333 20.4932Z'
        stroke={color}
        strokeWidth='2'
        strokeMiterlimit='10'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </svg>
  )
}

export default Document
